/**
 * TEMPORARY — V2 design-review feedback widget. REMOVE BEFORE PRODUCTION LAUNCH.
 *
 * Enabled at runtime on every host EXCEPT the production domains below, so
 * review deployments (testnet-app-2.leverup.xyz, *.vercel.app, localhost) get
 * it with zero Vercel config. NEXT_PUBLIC_V2_FEEDBACK=1/0 force-overrides.
 * Backend is Lark's Railway instance (hardcoded in public/v2-feedback/feedback.js).
 *
 * To remove for launch, delete:
 *   1. src/features/V2Feedback/            (this directory)
 *   2. public/v2-feedback/                 (script + board.html)
 *   3. the <V2FeedbackWidget /> line in src/pages/_app.tsx
 *   4. NEXT_PUBLIC_V2_FEEDBACK from .env.v2local
 */
import Script from 'next/script';
import { useEffect, useState } from 'react';

const PRODUCTION_HOSTS = new Set([
  'app.leverup.xyz',
  'www.leverup.xyz',
  'leverup.xyz',
]);

export const V2FeedbackWidget = () => {
  // decided post-mount: hostname is unknown during SSR
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    const forced = process.env.NEXT_PUBLIC_V2_FEEDBACK;
    if (forced === '0') return;
    if (forced === '1') {
      setEnabled(true);

      return;
    }
    setEnabled(!PRODUCTION_HOSTS.has(window.location.hostname));
  }, []);

  if (!enabled) return null;

  return <Script src="/v2-feedback/feedback.js" strategy="lazyOnload" />;
};
